<template>
  <BaseModal
    :title="'Importação por planilha'"
    hookSufix="DrmImportModal"
    :disableDefaultPadding="true"
    :onCloseHook="onCloseHook"
    :onOpenHook="onOpenHook"
    :persistent="false"
    :hideCloseBtn="true"
    :minHeight="minHeight"
    :modalWidth="'690px'"
    :fullscreen="isMobileBreakpoint"
  >
    <template #content>
      <div class="w-full d-flex px-3 justify-space-between pt-6 pl-6">
        <div class="d-flex">
          <div class="d-flex flex-column">
            <span class="body-bold-medium">{{
              $t('message.pages.drm.importCsvModal.title')
            }}</span>
            <span class="body-regular-smaller neutral-40-light--text">
              {{ $t('message.pages.drm.importCsvModal.description') }}
              <!-- <a
                target="_blank"
                type="secondary"
                size="xsmall"
                :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
              >
                {{ $t('message.memberGetMember.faqModal.article') }}

                <v-icon size="12">mdi-open-in-new</v-icon>
              </a> -->
            </span>
          </div>
        </div>
        <v-btn icon @click="handleClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <div class="container-title px-2">
        <base-drop-zone
          @file-uploaded="handleFileInput"
          :heightCard="'570'"
          :heightDropzone="'500'"
          :typeFile="accept.toString().replace(', ', ',')"
          :textTitleType="$t('message.pages.drm.importCsvModal.dropZoneTitle')"
          :textSubTitleType="
            $t('message.pages.drm.importCsvModal.dropZoneDescription')
          "
          :textHelper="$t('message.pages.drm.importCsvModal.dropZoneFile')"
          :linkTextHelper="$t('message.pages.drm.importCsvModal.hrefLink')"
        />
      </div>
    </template>
  </BaseModal>
</template>
<script>
import { mapState } from 'vuex'
import BaseDropZone from '@/components/BaseDropZone.vue'
import BaseModal from '@/components/BaseModal'
export default {
  components: { BaseDropZone, BaseModal },
  name: 'DrmImportModal',
  props: {
    type: {
      type: String,
      required: true,
    },
    accept: {
      type: Array,
      default: () => ['.csv', '.xlsx', '.xls', '.odt'],
    },
  },
  computed: {
    ...mapState({
      isMobileBreakpoint: (state) => state.user.isMobileBreakpoint,
    }),
    minHeight() {
      return this.isMobileBreakpoint ? '100vh' : 'auto'
    },
  },
  data() {
    return {
      onCloseHook: () => {
        // this.$root.$emit('closeDrmImportModal')
      },
      onOpenHook: () => {
        // this.$root.$emit('openDrmImportModal')
      },
    }
  },
  methods: {
    handleFileInput(file) {
      const isOver10MB = file.size > 5 * 1024 * 1024
      if (isOver10MB) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.$t('message.ai.sizeNotAllowed'),
          type: 'error',
        })
        return
      }
      let fileExtension =
        file?.name?.substring(
          file?.name?.lastIndexOf('.'),
          file?.name?.length
        ) || file?.name
      if (!this.accept.includes(fileExtension)) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: this.t('message.ai.formatNotAllowed'),
          type: 'error',
        })
        return
      }
      this.$root.$emit('openDrmUploadModal', { file: file })
      this.handleClose()
    },
    handleClose() {
      this.$root.$emit('closeDrmImportModal')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .dropzone {
  align-items: center !important;
}
</style>
